import ApiClient, { handleApiCall } from "../api";

export const createAttributes = (createPayload) => handleApiCall("post", "attributes", createPayload);

/** List/detail reads — no global loader; pages use inline skeletons. */
export const getAttributes = () => ApiClient.get("attributes");

export const getAttributesById = (id) => ApiClient.get(`attributes/${id}`);

export const removeAttribute = (id) => handleApiCall("delete", `attributes/${id}`);

export const updateAttributes = (id, updatePayload) => handleApiCall("patch", `attributes/${id}`,updatePayload)

